import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import FullScreenLoader from "../FullScreenLoader";

const AddWithdraw = ({ title, formData, setFormData, isLoading, handelSubmit , handleClose , userName , dilaogShow }) => {

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div>
      <FullScreenLoader show={isLoading} />
      <Modal
        // id="AddWithdraw"
        show={dilaogShow}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <InputGroup className="mb-3">
              <InputGroup.Text>
                <small>Transaction By:</small>
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="SubAdmin"
                value={userName}
                disabled
                style={{ fontSize: "10px" }}
              />
              <Form.Control
                type="number"
                placeholder="Amount"
                name="amount"
                onChange={handleChange}
                value={formData.amount || ""}
              />
            </InputGroup>
            <Form.Control
              type="text"
              placeholder="Remarks *"
              name="remarks"
              onChange={handleChange}
              value={formData.remarks || ""}
              required
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handelSubmit} style={{backgroundColor : '#4682b4'}}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default React.memo(AddWithdraw);
